export enum ViewResourceEnum {
  card = 'card',
  list = 'list',
}
